import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  Navigate,
} from "react-router-dom";

import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";

import Home from "./pages/Home";
import About from "./pages/About";
import Join from "./pages/Join";
import Hrcom from "./pages/Hrcom";
import Industry from "./pages/Industry";
import Branding from "./pages/Branding";
import TermsConditions from "./pages/Terms_Condition";
import Privacy from "./pages/Privacy";
import Refund from "./pages/Refund";
import Ourteam from "./pages/Ourteam";
import Ourpartner from "./pages/Ourpartner";
import Joinmodel from "./components/JoinModel";
import GetCertifiedPage from "./pages/Getcertifiedpage";
import Eventpage from "./pages/Eventpage";
import Eventform from "./components/Event_form";
import Dashboard from "./pages/dashboard";
import Login from "./components/Login";
import Gallery from "./pages/gallery";
import ResetPassword from "./pages/ResetPassword";
import ContactForm from "./pages/ContactForm";
import Hrc2026 from "./pages/Hrc2026";



import "./App.css";

// Dashboard, admin login, and reset-password have their own layout,
// so hide Header/Footer on all of these (and anything under them).
const NO_LAYOUT_ROUTES = [
  "/dashboard",
  "/admin/login",
  "/admin/reset-password",
  "/admin/forgot-password",
];

// ------------------------------------------------------------
// Guards /dashboard — if there's no logged-in admin in localStorage,
// redirect straight to /admin/login instead of rendering the page.
// ------------------------------------------------------------
function ProtectedRoute({ children }) {
  const admin = localStorage.getItem("vnk_admin");
  if (!admin) {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
}

function AppContent() {
  const location = useLocation();

  const hideLayout = NO_LAYOUT_ROUTES.some((route) =>
    location.pathname.startsWith(route)
  );

  return (
    <>
      <ScrollToTop />

      {!hideLayout && <Header />}

      <Routes>
        <Route path="/" element={<Navigate to="/home" replace />} />

        <Route path="/home" element={<Home />} />
        <Route path="/whatWeDo" element={<About />} />
        <Route path="/jointhecommunity" element={<Join />} />
         <Route path="/contact" element={<ContactForm />} />
        <Route path="/hrcommunity" element={<Hrcom />} />
        <Route path="/industryacademia" element={<Industry />} />
        <Route path="/employeebranding" element={<Branding />} />
        <Route path="/terms" element={<TermsConditions />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/refund" element={<Refund />} />
        <Route path="/getcertified" element={<GetCertifiedPage />} />
        <Route path="/ourteam" element={<Ourteam />} />
        <Route path="/ourpartner" element={<Ourpartner />} />
        <Route path="/joinmodel" element={<Joinmodel />} />
        <Route path="/events" element={<Eventpage />} /> 
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/hrc2026" element={<Hrc2026 />} />
       <Route path="/eventform" element={<Eventform />} /> 
        <Route path="/admin/login" element={<Login />} />
        <Route path="/admin/reset-password/:token" element={<ResetPassword />} />
       

        {/* Dashboard — now guarded */}
        <Route
          path="/dashboard"
          element={
            
              <Dashboard />
            
          }
        />

        <Route path="*" element={<Navigate to="/home" replace />} />
      </Routes>

      {!hideLayout && <Footer />}
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;